import "./CreateUserForm.scss"
import Form, { EmailRule, RequiredRule, SimpleItem } from "devextreme-react/form";
import { useNavigate } from "react-router-dom";
import { Item, Toolbar } from "devextreme-react/toolbar";
import { Button } from "devextreme-react/button";
import { useState } from "react";
import { showErrorMessage, showSuccessMessage } from "../../../../utils/messages";
import { LoadPagePanel } from "../../../../components";
import { StoreUserDetails } from "../types/StoreUserDetails";
import { useCreateStoreUser } from "../api/create-user";
import { useAuth } from "../../../../contexts/auth";
import { useGetCompany } from "../../../../api/company";

export default function CreateUserForm() {

	const { user } = useAuth();
	const userCompany = useGetCompany(user?.companyId);

	const navigate = useNavigate();

	const [formState, setFormState] = useState<StoreUserDetails>({} as StoreUserDetails);

	const createUser = useCreateStoreUser(formState,
		() => {
			showSuccessMessage("User has been created successfully");
			navigate('/');
		},
		(error) => {
			showErrorMessage(error);
		})

	return (
		<div className="dx-card user-form">
			<Form
				formData={formState}
				colCount={2}
				labelLocation="left"
				validationGroup="userValidationGroup"
				showValidationSummary={true}
				onFieldDataChanged={(e) => {

					let userName = formState.userName;
					let initials = formState.initials;
					if (e.dataField === "firstName" && e.value && formState.lastName) {
						userName = e.value + '.' + formState.lastName;
						initials = e.value[0] + formState.lastName[0];
					}
					else if (e.dataField === "lastName" && e.value && formState.firstName) {
						userName = formState.firstName + '.' + e.value
						initials = formState.firstName[0] + e.value[0];
					}

					if (userName !== formState.userName || initials !== formState.initials) {
						setFormState({ ...formState, userName: userName, initials: initials });
					}
				}}
			>
				<SimpleItem
					dataField="firstName"
					isRequired={true}
					editorOptions={{
						maxLength: 128
					}}
				/>

				<SimpleItem
					dataField="lastName"
					isRequired={true}
					editorOptions={{
						maxLength: 128
					}}
				/>

				<SimpleItem
					dataField="userName"
					isRequired={true}
					editorOptions={{
						maxLength: 128
					}}
				/>

				<SimpleItem
					dataField="initials"
					isRequired={true}
					editorOptions={{
						maxLength: 20
					}}
				/>

				<SimpleItem dataField="emailAddress"
					editorOptions={{
						maxLength: 200
					}}
				>
					<RequiredRule message="Email Address is required" />
					<EmailRule />
				</SimpleItem>

				<SimpleItem dataField="altEmailAddress"
					editorOptions={{
						maxLength: 200
					}}
				>
					<EmailRule />
				</SimpleItem>

				<SimpleItem
					dataField="phone"
					editorOptions={{
						mask: 'X00-000-0000',
						maskRules: {
							X: /[02-9]/,
						},
						useMaskedValue: true,
						showMaskMode: 'onFocus'
					}}>
				</SimpleItem>

				<SimpleItem
					dataField="phoneExtension"
					editorOptions={{
						mask: '##########',
						showMaskMode: 'onFocus'
					}}>
				</SimpleItem>

				<SimpleItem
					dataField="fax"
					editorOptions={{
						mask: 'X00-000-0000',
						maskRules: {
							X: /[02-9]/,
						},
						useMaskedValue: true,
						showMaskMode: 'onFocus'
					}}>
				</SimpleItem>

				<SimpleItem
					dataField="cellPhone"
					editorOptions={{
						mask: 'X00-000-0000',
						maskRules: {
							X: /[02-9]/,
						},
						useMaskedValue: true,
						showMaskMode: 'onFocus'
					}}>
				</SimpleItem>

				<SimpleItem dataField="employeeNumber"
					isRequired={userCompany.data?.requireEmployeeNumber}
					editorOptions={{
						maxLength: 32
					}}
				/>
			</Form>

			<Toolbar className="button-toolbar">

				<Item location="after">
					<Button
						text="Submit"
						useSubmitBehavior={true}
						validationGroup="userValidationGroup"
						onClick={(e) => {

							let isValid = e.validationGroup.validate().isValid;
							if (isValid) {
								createUser.mutate();
							}
						}}
					></Button>
				</Item>
			</Toolbar>
			<LoadPagePanel visible={createUser.isLoading} />
		</div>
	)
}
